import React, { Component } from 'react';
import { Flex, InfoBox, Text, Icon } from 'core/components';
import { timezone, dateTimeFormatter } from 'core/util/dateUtils';

export default class AgentDowntimeSummary extends Component {
  static defaultProps = {
    activeTimeslot: null,
    resultTimeMs: null
  };

  render() {
    const { resultTimeMs, activeTimeslot } = this.props;

    if (activeTimeslot) {
      return (
        <Flex p={2} gap={2} justifyContent="space-between">
          <InfoBox mb={0} heading={`Selected Time (${timezone.value})`}>
            {dateTimeFormatter({ value: resultTimeMs })}
          </InfoBox>

          <InfoBox
            mb={0}
            heading={
              <Flex alignItems="center">
                <Icon icon="full-circle" iconSize={6} mr="4px" />
                <Text textTransform="uppercase">Errors</Text>
              </Flex>
            }
          >
            <Flex>{activeTimeslot.error > 0 && <Text>{activeTimeslot.error}</Text>}</Flex>
          </InfoBox>
        </Flex>
      );
    }

    return null;
  }
}
